import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { customerInvoicesCols } from './models';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { Search } from '../Search';
import { resetCustomerInvoicesSearch, fetchCustomerInvoicesSearch } from 'actions/invoices';
import { invoiceTypeDialog } from 'views/customer-billing/raiseCreditNotes/list/static';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { isFeatureEnabled, lastThreeMonthsFilters } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
interface IMapDispatchToProps {
    fetchCustomerInvoicesSearch: (pageNumber: number, pageSize: number) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    reset: () => void;
}

interface IMapStateToProps {
    isLoading: boolean;
    hasError: boolean;
    pendingError: string | string[],
    customerInvoices: any;
    featureToggles: IFeatureToggleModel[];
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    withoutFilters: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    clearFilters: boolean,
    isFetchinProgress: boolean;
    pendingError: string | string[];
    dateFrom: boolean,
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null,
    activeTab: number,
    result: any[]
}
export class _SearchCustomerInvoices extends Component<IProps, IState>{
    public generalInputRef: any = React.createRef();
    public tableRef: any = React.createRef();
    public state = {
        sorted: [],
        withoutFilters: false,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        dateFrom: false,
        pendingError: '',
        result: [],
        clearFilters: false,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: '',
        activeTab: 1
    };
    constructor(props: any) {
        super(props);
    }
    public componentWillUnmount() {
        this.props.resetSort()
        if (this.state.withoutFilters) {
            this.props.history.location.search = ''
        }
    }
    public componentDidMount() {
        this.setState({
            isFetchinProgress: false
        })
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.hasError !== props.hasError) {
            this.setState({
                showDialog: this.props.hasError,
                isFetchinProgress: false,
                errorMsg: this.props.hasError.toString() ? this.props.hasError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.customerInvoices !== props.customerInvoices) {
            this.setData(this.props.customerInvoices.result, this.props.customerInvoices.page, this.props.customerInvoices.pageSize, this.props.customerInvoices.totalCount)
        }
        if (this.props.pendingError !== props.pendingError && this.props.hasError === true) {
            const error = isEmptyError(this.props.pendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
    }

    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        const FILTERS = [<FiltersInput
            key="internalInvoiceNumber"
            name="internalInvoiceNumber"
            id="internalInvoiceNumber"
            label="Internal Invoice Number"
        />,
        <FiltersInput
            key="sapInvoiceNumber"
            name="sapInvoiceNumber"
            id="sapInvoiceNumber"
            label="SAP Invoice Number"
        />,
        <FiltersInput
            key="invoiceCreatedBy"
            name="invoiceCreatedBy"
            id="invoiceCreatedBy"
            label="Invoice Created By"
        />,
        <FiltersSelect
            type="invoiceType"
            key="invoiceType"
            name="invoiceType"
            label="Invoice Type"
            options={invoiceTypeDialog}
        />,
        <FiltersSelect
            type="invoiceStatus"
            key="invoiceStatus"
            name="invoiceStatus"
            label="Invoice Status"
            options={[
                { optionText: 'Invoice Cancellation Requested', value: 'Invoice Cancellation Requested' },
                { optionText: 'Credit Note Requested', value: 'Credit Note Requested' },
                { optionText: 'Invoice Cancelled', value: 'Invoice Cancelled' },
                { optionText: 'Full Settled', value: 'Full Settled' },
                { optionText: 'Invoice in FinOps Created', value: 'Invoice in FinOps Created' },
                { optionText: 'Final Invoice Created', value: 'Final Invoice Created' },
                { optionText: 'Draft Invoice Created', value: 'Draft Invoice Created' },
                { optionText: 'Invoice Requested', value: 'Invoice Requested' },
                { optionText: 'Partial Settled', value: 'Partial Settled' },
                { optionText: 'Credit Note Created', value: 'Credit Note Created' }
            ]}
        />,
        <FiltersDateInput
            key="invoiceDateFrom"
            name="invoiceDateFrom"
            label="Date (From)"
            relatedField="invoiceDateTo"
            setValidity={(val: any) => this.setState({ dateFrom: val })}
            isInvalid={this.state.dateFrom}
            type="dateFromTo"
            withTime={false}
        />,
        <FiltersDateInput
            key="invoiceDateTo"
            name="invoiceDateTo"
            label="Date (to)"
            relatedField="invoiceDateFrom"
            setValidity={(val: any) => this.setState({ dateFrom: val })}
            isInvalid={this.state.dateFrom}
            type="dateFromTo"
            withTime={false}
        />]
        return (
            <Search triggerFetch={() => this.targetFetch()}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="CustomerBillingFilters"
                    requireFilters={true}
                    defaultFilters={lastThreeMonthsFilters('invoiceDateFrom', 'invoiceDateTo')}
                    fetchFunction={() => this.fetchReset()}
                    filters={FILTERS}
                    withoutFilters={this.state.withoutFilters}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.dateFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('input[type=number]')) {
                            this.tableRef.current.querySelector('input[type=number]').value = 1
                        }
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            result: [],
                            clearFilters: false,
                            hasData: false
                        })
                    }}
                />
                <TabComponent name="search-results" activeTab={this.state.activeTab - 1} navLinks={[{
                    id: 1,
                    title: isExtraDocumentFeatureEnabled ? 'Document/ETS' : (isHblConsumptionEnabled ? 'FCR/HBL/ETS' : 'FCR/ETS'),
                    emptyLabel: ''
                }]}
                    callbackFc={(e: number) => this.setState({ activeTab: e })} />
                <GeneralTable
                    id="jobCosting-customer-invoices"
                    cols={customerInvoicesCols}
                    data={this.state.result}
                    pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                    isLoading={this.props.isLoading}
                    fetchData={this.justFetch}
                    refFwd={null}
                    linkAction={(e: any) => {
                        const getPath = e.category && e.category.toLowerCase() === 'fcr' ? 'origin' : 'destination';
                        this.props.history.push(`/customer-billing/raise-credit-notes/${getPath}/${e.internalInvoiceNumber}`);
                    }}
                />
            </Search>
        );
    }
    private setData = (data: any[], page: number, pageSize: number, totalCount: number) => {
        let newData: any[] = data;
        if (this.state.activeTab !== 1) {
            if (this.state.activeTab === 2) {
                newData = data.filter((entry: any) => entry.category === 'FCR');
            } else {
                newData = data.filter((entry: any) => entry.category === 'ETS');
            }
        }
        this.setState({
            result: newData,
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true
        })
    }
    private resetDates = () => {
        if (this.props.customerInvoices && this.props.customerInvoices.result.length > 0) {
            this.props.reset()
        }
        this.setState({
            sorted: [],
            result: [],
            page: 1,
            totalCount: 0,
            dateFrom: false,
            isFetchinProgress: true,
            shouldClear: true,
            clearFilters: true,
            hasData: false
        })
    };
    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-customer-invoices') ?
        localStorage.getItem('pageSize-ListTable jobCosting-customer-invoices') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        })
        this.props.fetchCustomerInvoicesSearch(page, tempPageSize)
    }
    private fetchReset = (page: number = this.state.page = 1, pageSize: number = 10) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('.-pageJump input')) {
            this.tableRef.current.querySelector('input[type=number]').value = 1
        }
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
                isFetchinProgress: true
            });
            this.targetFetch(props.page, props.pageSize)
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isLoading: state.invoices.loadingCustomerInvoices,
    hasError: state.invoices.errorCustomerInvoices,
    pendingError: state.invoices.pendingError,
    customerInvoices: state.invoices.searchCustomerInvoices,
    featureToggles: state.featureToggle.featureToggles
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchCustomerInvoicesSearch: (pageNumber: number, pageSize: number) => dispatch(fetchCustomerInvoicesSearch(pageNumber, pageSize)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    reset: () => dispatch(resetCustomerInvoicesSearch())
});
const __SearchCustomerInvoices = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchCustomerInvoices);
export const SearchCustomerInvoices = withRouter(__SearchCustomerInvoices);